import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CalendarIcon, MessageSquareIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    eventType: '',
    groupSize: '',
    eventDates: '',
    budget: '',
    message: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your inquiry! We will contact you shortly.');
  };
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-739">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-740">
        <div className="container mx-auto px-4 md:px-6" data-id="element-741">
          <div className="max-w-3xl" data-id="element-742">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-743">
              Contact Us
            </h1>
            <p className="text-xl text-white/90" data-id="element-744">
              Ready to go from boardroom to beach? Let's start planning your
              exceptional event.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-16 bg-white" data-id="element-745">
        <div className="container mx-auto px-4 md:px-6" data-id="element-746">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-747">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-748">
              Get in Touch
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-749">
              Choose the method that works best for you. Our team is ready to
              help plan your perfect event.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-750">
            <Card className="text-center h-full" data-id="element-751">
              <CardHeader className="flex flex-col items-center" data-id="element-752">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-753">
                  <CalendarIcon className="h-8 w-8 text-[#0099A1]" data-id="element-754" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-755">
                  Book a Call
                </h3>
              </CardHeader>
              <CardBody data-id="element-756">
                <p className="text-[#374047]/80 mb-6" data-id="element-757">
                  Schedule a 15-minute discovery call with our team to discuss
                  your event needs.
                </p>
                <Button variant="primary" data-id="element-758">Book Discovery Call</Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-759">
              <CardHeader className="flex flex-col items-center" data-id="element-760">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-761">
                  <MessageSquareIcon className="h-8 w-8 text-[#0099A1]" data-id="element-762" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-763">WhatsApp</h3>
              </CardHeader>
              <CardBody data-id="element-764">
                <p className="text-[#374047]/80 mb-6" data-id="element-765">
                  Connect with us instantly via WhatsApp for quick questions and
                  inquiries.
                </p>
                <Button variant="outline" className="bg-[#25D366] text-white border-[#25D366] hover:bg-[#25D366]/90" href="https://wa.me/1234567890" data-id="element-766">
                  Start WhatsApp Chat
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-767">
              <CardHeader className="flex flex-col items-center" data-id="element-768">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-769">
                  <MailIcon className="h-8 w-8 text-[#0099A1]" data-id="element-770" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-771">Email Us</h3>
              </CardHeader>
              <CardBody data-id="element-772">
                <p className="text-[#374047]/80 mb-6" data-id="element-773">
                  Send us an email with your event details and we'll respond
                  within 24 hours.
                </p>
                <Button variant="outline" href="mailto:events@destameet.com" data-id="element-774">
                  events@destameet.com
                </Button>
              </CardBody>
            </Card>
          </div>

          {/* RFP Form */}
          <div className="max-w-3xl mx-auto" data-id="element-775">
            <h2 className="text-2xl font-bold text-[#374047] mb-6 text-center" data-id="element-776">
              Request for Proposal
            </h2>
            <Card data-id="element-777">
              <CardBody data-id="element-778">
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-779">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-780">
                    <div data-id="element-781">
                      <label htmlFor="name" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-782">
                        Your Name *
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-783" />
                    </div>
                    <div data-id="element-784">
                      <label htmlFor="email" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-785">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-786" />
                    </div>
                    <div data-id="element-787">
                      <label htmlFor="company" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-788">
                        Company Name *
                      </label>
                      <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-789" />
                    </div>
                    <div data-id="element-790">
                      <label htmlFor="phone" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-791">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-792" />
                    </div>
                    <div data-id="element-793">
                      <label htmlFor="eventType" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-794">
                        Event Type *
                      </label>
                      <select id="eventType" name="eventType" value={formData.eventType} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-795">
                        <option value="" data-id="element-796">Select Event Type</option>
                        <option value="meeting" data-id="element-797">Meeting/Retreat</option>
                        <option value="incentive" data-id="element-798">Incentive Trip</option>
                        <option value="brand" data-id="element-799">Brand Launch</option>
                        <option value="other" data-id="element-800">Other</option>
                      </select>
                    </div>
                    <div data-id="element-801">
                      <label htmlFor="groupSize" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-802">
                        Group Size *
                      </label>
                      <select id="groupSize" name="groupSize" value={formData.groupSize} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-803">
                        <option value="" data-id="element-804">Select Group Size</option>
                        <option value="small" data-id="element-805">Small (10-30 people)</option>
                        <option value="medium" data-id="element-806">Medium (31-100 people)</option>
                        <option value="large" data-id="element-807">Large (101-300 people)</option>
                        <option value="xlarge" data-id="element-808">X-Large (301+ people)</option>
                      </select>
                    </div>
                    <div data-id="element-809">
                      <label htmlFor="eventDates" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-810">
                        Approximate Event Dates
                      </label>
                      <input type="text" id="eventDates" name="eventDates" value={formData.eventDates} onChange={handleChange} placeholder="Month/Year or flexible" className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-811" />
                    </div>
                    <div data-id="element-812">
                      <label htmlFor="budget" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-813">
                        Budget Range
                      </label>
                      <select id="budget" name="budget" value={formData.budget} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-814">
                        <option value="" data-id="element-815">Select Budget Range</option>
                        <option value="economy" data-id="element-816">
                          Economy ($300-500 per person per night)
                        </option>
                        <option value="premium" data-id="element-817">
                          Premium ($500-800 per person per night)
                        </option>
                        <option value="luxury" data-id="element-818">
                          Luxury ($800+ per person per night)
                        </option>
                        <option value="flexible" data-id="element-819">
                          Flexible / Not Sure Yet
                        </option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-820">
                    <label htmlFor="message" className="block text-sm font-medium text-[#374047] mb-1" data-id="element-821">
                      Tell Us About Your Event Goals
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-822"></textarea>
                  </div>
                  <div className="text-center" data-id="element-823">
                    <Button type="submit" variant="primary" size="lg" data-id="element-824">
                      Submit Request
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-825" />
    </div>;
}